import { FC } from "react";

export const ExternalLink: FC<{ url: string; label: string }> = ({ url, label }) => {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="text-xs text-grey-400 font-semibold hover:underline hover:text-blue-400">
      {label}
    </a>
  );
};
